import React, { useState } from 'react';
import { employeeApi } from '../../../../../api/employeeApi';
import { useNavigate } from 'react-router-dom';

const AddEmployees = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    employeeName: '',
    employeeCompany: '',
    employeeProfile: null,
    gender: '',
    joiningDate: '',
    dob: '',
    password: '',
    email: '',
    phone: '',
    department: '',
    designation: '',
    address: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      await employeeApi.addEmployee(formData);
      setFormData({
        employeeName: '',
        employeeCompany: '',
        employeeProfile: null,
        gender: '',
        joiningDate: '',
        dob: '',
        password: '',
        email: '',
        phone: '',
        department: '',
        designation: '',
        address: ''
      });
      alert('Employee added successfully!');
      navigate('/employees-all');
    } catch (err) {
      setError(err.message || 'Failed to add employee. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: type === 'file' ? files[0] : value
    }));
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <h3 className="fw-bold">Add Employees</h3>
      <div className="card p-4">
        <form className="row g-3" onSubmit={handleSubmit}>

          {/* --- Employee Basic Info --- */}
          <div className="col-md-6">
            <div className="form-floating">
              <input
                type="text"
                name="employeeName"
                value={formData.employeeName}
                onChange={handleInputChange}
                className="form-control"
                id="employeeName"
                placeholder="Employee Name"
              />
              <label htmlFor="employeeName">Employee Name</label>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-floating">
              <input
                type="text"
                name="employeeCompany"
                value={formData.employeeCompany}
                onChange={handleInputChange}
                className="form-control"
                id="employeeCompany"
                placeholder="Company Name"
              />
              <label htmlFor="employeeCompany">Employee Company</label>
            </div>
          </div>

          {/* --- Department & Designation --- */}
          <div className="col-md-6">
            <div className="form-floating">
              <input
                type="text"
                name="department"
                value={formData.department}
                onChange={handleInputChange}
                className="form-control"
                id="department"
                placeholder="Department"
              />
              <label htmlFor="department">Department/Unit</label>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-floating">
              <input
                type="text"
                name="designation"
                value={formData.designation}
                onChange={handleInputChange}
                className="form-control"
                id="designation"
                placeholder="Designation"
              />
              <label htmlFor="designation">Designation</label>
            </div>
          </div>

          {/* --- Email & Phone --- */}
          <div className="col-md-6">
            <div className="form-floating">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="form-control"
                id="email"
                placeholder="Email ID"
              />
              <label htmlFor="email">Email ID</label>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-floating">
              <input
                type="number"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                className="form-control"
                id="phone"
                placeholder="Phone Number"
              />
              <label htmlFor="phone">Phone</label>
            </div>
          </div>

          {/* --- DOB & Joining Date --- */}
          <div className="col-md-6">
            <div className="form-floating">
              <input
                type="date"
                name="dob"
                value={formData.dob}
                onChange={handleInputChange}
                className="form-control"
                id="dob"
                placeholder="Date of Birth"
              />
              <label htmlFor="dob">Date of Birth</label>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-floating">
              <input
                type="date"
                name="joiningDate"
                value={formData.joiningDate}
                onChange={handleInputChange}
                className="form-control"
                id="joiningDate"
                placeholder="Joining Date"
              />
              <label htmlFor="joiningDate">Joining Date</label>
            </div>
          </div>

          {/* --- Gender & Password --- */}
          <div className="col-md-6">
            <div className="form-floating">
              <select
                name="gender"
                value={formData.gender}
                onChange={handleInputChange}
                className="form-select"
                id="gender"
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
              <label htmlFor="gender">Gender</label>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-floating">
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                className="form-control"
                id="password"
                placeholder="Password"
              />
              <label htmlFor="password">Password</label>
            </div>
          </div>

          {/* --- Address --- */}
          <div className="col-12">
            <div className="form-floating">
              <textarea
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                className="form-control"
                id="address"
                rows="3"
                placeholder="Employee Address"
              ></textarea>
              <label htmlFor="address">Address</label>
            </div>
          </div>

          {/* --- Profile Upload --- */}
          <div className="col-md-6">
            <label className="form-label text-muted">Employee Profile</label>
            <input
              className="form-control"
              type="file"
              name="employeeProfile"
              onChange={handleInputChange}
            />
          </div>

          {/* --- Error Message --- */}
          {error && (
            <div className="col-12">
              <div
                className="alert alert-danger alert-dismissible fade show"
                role="alert"
              >
                {error}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
            </div>
          )}

          {/* --- Submit Button --- */}
          <div className="col-6 d-flex justify-content-end mt-5">
            <button
              type="submit"
              className="btn btn-primary btn-lg rounded"
              style={{ width: 'auto', minWidth: '180px' }}
              disabled={loading}
            >
              {loading ? 'Adding Employee...' : 'Register Employee'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEmployees;